
import { useEffect } from 'react';

interface LinkToPreload {
  url: string;
  as?: 'style' | 'script' | 'font' | 'image' | 'document';
  rel?: 'preload' | 'prefetch' | 'preconnect' | 'dns-prefetch';
}

/**
 * Component to preload important pages and resources
 * This improves page speed and SEO metrics like LCP, CLS, etc.
 */
export const PreloadLinks = () => {
  useEffect(() => {
    const importantLinks: LinkToPreload[] = [
      // Preconnect to important domains
      { url: 'https://edgefi.com', rel: 'preconnect' },
      { url: 'https://fonts.googleapis.com', rel: 'preconnect' },
      { url: 'https://fonts.gstatic.com', rel: 'preconnect' },
      { url: 'https://supabase.io', rel: 'preconnect' },
      
      // DNS prefetch for performance
      { url: 'https://fonts.googleapis.com', rel: 'dns-prefetch' },
      { url: 'https://fonts.gstatic.com', rel: 'dns-prefetch' },
      
      // Prefetch important pages for navigation
      { url: '/about', rel: 'prefetch' },
      { url: '/services/managed-cybersecurity', rel: 'prefetch' },
      { url: '/services/microsoft-365-security', rel: 'prefetch' },
      { url: '/get-started', rel: 'prefetch' },
      { url: '/blog', rel: 'prefetch' },
      
      // Preload critical resources
      { url: '/lovable-uploads/3faf62f0-dd43-43cc-82c2-9329f89d269f.png', rel: 'preload', as: 'image' },
      { url: '/og-image.png', rel: 'preload', as: 'image' }
    ];
    
    // Add these links to the document head
    importantLinks.forEach(link => {
      const linkElement = document.createElement('link');
      linkElement.href = link.url;
      linkElement.rel = link.rel || 'prefetch';
      if (link.as) {
        linkElement.setAttribute('as', link.as);
      }
      document.head.appendChild(linkElement);
    });
    
    return () => {
      // Clean up links when component unmounts
      document.querySelectorAll('link[rel="prefetch"], link[rel="preload"]').forEach(link => {
        if (importantLinks.some(l => l.url === link.getAttribute('href'))) {
          link.remove();
        }
      });
    };
  }, []);
  
  return null; // This component doesn't render anything
};

export default PreloadLinks;
